import { DocumentationPage } from './_article.jsx';
export default function AnalyticsPage({
  article,
  articles
}) {
  return <DocumentationPage article={article} articles={articles} />;
}